@if (isAvailableOffline()) {
  <mat-icon class="icon" [class.conflict]="isConflicted()">article_person</mat-icon>
} @else {
  <mat-icon class="icon">description</mat-icon>
}
<a
  lfwShouldOpenInNewTab
  [routerLink]="getLink()"
  role="link"
  class="doku"
  [attr.aria-describedby]="isConflicted() ? 'conflict-' + order().id : null">
  <div class="bigtext ordertext" [class.conflict]="isConflicted()">
    {{ order().text }}
    @if (isConflicted()) {
      <mat-icon class="conflict-icon" aria-hidden="true" [matTooltip]="'ORDERS.CONFLICT_TOOLTIP_ONLINE' | translate"
        >info</mat-icon
      >
    }
  </div>
  <div class="states">
    @if (getOrderStateText(); as orderStateText) {
      <div class="text state small-text" [style]="getOrderStateStyle()">{{ orderStateText }}</div>
    }
    @if (getSubStateText(); as subStateText) {
      <div class="text state small-text" [style]="getSubStateStyle()">{{ subStateText }}</div>
    }
    @if (getScenarioText(); as scenarioText) {
      <div class="text state small-text" [style]="getScenarioStyle()">{{ scenarioText }}</div>
    }
  </div>
</a>

@if (isConflicted()) {
  <span [id]="'conflict-' + order().id" class="visually-hidden">
    {{ 'ORDERS.CONFLICT_TOOLTIP_ONLINE' | translate }}
  </span>
}

<div class="actions">
  <lfw-online-order-list-actions
    [order]="order()"
    [userCanCancel]="userCanCancel"
    (finishOrder)="finishOrder()"
    (checkoutOrder)="checkoutOrder()" />
</div>
